import { render } from "./BaseCheckbox.vue?vue&type=template&id=a95057f6&scoped=true"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=a95057f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a95057f6"]])

export default __exports__